import React, { Component } from 'react';

import TopComponent from './../components/ChartTopDashboard/TopComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class TopDB extends Component {

  render() {

    return (
      <TopComponent
        name={this.props.name}
        title={this.props.title}
        data={this.props.data}
        watchMenu={this.props.watchMenu}
        openDialog={this.props.openDialog}
        onClickGraphic={this.props.onClickGraphic}
        seeMore={this.props.seeMore}
        cantBars={this.props.cantBars}
        noSelect={this.props.noSelect}
        seeTen={this.props.seeTen}
      />
    );
  }
}

export default TopDB;